var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","mb-2":""}},[_c('div',{staticClass:"caption pb-1 opacity-54"},[_vm._v(_vm._s(_vm.fieldLabel))]),(_vm.href)?_c('a',{attrs:{"href":_vm.href,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.href))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }